 <template>
<div id="container" class="ninjageschichten">
    <div class="fullscreen_background hintergrund">
		<img class="img" src="/static/assets/ninjageschichten/Hintergrund.png" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <!-- <div class="moeve z30 hovering">
        <img class="img" src="/static/assets/ninjageschichten/Moeve.png" />
    </div> -->

    <div class="lord_knatterdorn z36">
        <img class="img" src="/static/assets/ninjageschichten/Lord_Knatterdorn.png" />
    </div>
    <div class="hugi z30">
        <img class="img" src="/static/assets/ninjageschichten/Hugi.png" />
    </div>
	<div class="gigi z30">
        <img class="img" src="/static/assets/ninjageschichten/Gigi.png" />
    </div>
    <div class="dubix z30">
        <img class="img" src="/static/assets/ninjageschichten/Dubix.png" />
    </div>
	    <div class="libero z40"> 
        <img class="img" src="/static/assets/ninjageschichten/Libero.png" />
    </div>
    <div class="lampe lampe_animation z35">
    </div>
	<div class="ratte z36 ratte_animation">
    </div>
	<div class="sterne z30 sterne_animation">
    </div>
    <router-link to="/eiswelt" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil.png" />
    </router-link>

    <router-link to="/pferdegeschichten" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/ninjageschichten/Geschichte.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Gigi_Ninjiki_LANGSAM.mp3" jsonurl="/static/assets/geschichten/gigi_ausgabe4.json" content=".ninjageschichten" target="ninjageschichten_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="ninjageschichten_target">
        <p>Die Fußgänger rannten davon und pressten sich an die Häuserfronten. Autos und Busse fuhren auf die Gehsteige und hielten dort an. So war es immer, wenn Lord Knatterdon mit seiner Motorradgang die Straßen unsicher machte und sie mit ihren lautstarken, stinkenden Maschinen rücksichtslos durch die Straßenschluchten Nin Yorks rasten. Die Nin Yorker hatten sich daran gewöhnt. An die Furcht vor der Gang, aber auch daran, dass gegen sie nichts auszurichten war. Hätten sie heute aber nach oben anstatt ängstlich nach unten geblickt, dann hätten sie schon zu dieser Stunde gewusst, dass es immer Hoffnung und ein Ende aller Angst gibt. Denn oben, auf den Dächern, war ein Kliminja unterwegs und sprang von Wolkenkratzer zu Wolkenkratzer. Libero Bimako, Meister des Flugsprungs, sollte die Gang verfolgen. Er war mit einem GPS-Sender ausgerüstet und so konnten die anderen Kliminjas auf einem Bildschirm sehen, wo sich die Gang gerade befand, und ihr mit gebotenem Abstand hinterherfahren.  </p>
		  <p>Die Kliminjas hatten davon Wind bekommen, dass die Gang den Auftrag hatte, die giftigen Abfälle einer Fabrik in den Ninfluss zu werfen. Das mussten sie unbedingt verhindern! Schließlich wäre es nicht nur für die Tiere des Flusses hochgefährlich, sondern auch für alle, die am Fluss lebten und dort ihr Gemüse und Getreide anbauten. Libero Bimako stoppte jäh seine Verfolgungsjagd. Lord Knatterdon hatte unten den Befehl zum Stopp gegeben. Schnell sprang Libero Bimako an der Rückseite des Gebäudes nach unten, landete sicher und tastete sich mit Samtpfoten zu der Stelle vor, an der die Gang gehalten hatte. Doch außer den Motorrädern war dort nichts mehr zu sehen. Die Gang musste im Haus verschwunden sein. Er hörte einen wohlbekannten Pfiff. </p>
<p>Samurai Dubix! Da sah er ihn, er stand auf der gegenüberliegenden Straßenseite und neben ihm Gigi Ninjiki und Hugi Hu. Samurai Dubix gab ihm Zeichen, dass die Gang im Haus verschwunden war, und leise postierten sich die Kliminjas rechts und links von der Haustür. Da kamen sie! Sausepuff, Billy Bock und Mister Zylinder schoben einen Rollwagen schwer bepackt mit Giftmüll aus der Türe. „Los geht’s“, rief Gigi Ninjiki. Nun begann ein Kampf, von dem sich Nin York noch Jahrhunderte erzählen würde. Samurai Dubix, Meister der Steinwerdung, stürzte sich auf Sausepuff. Der war so verblüfft, dass ihm kaum Zeit blieb, seinen Wurfstern zu zücken. Blong! Ehe er sichs versah, landete das Schwert von Samurai Dubix auf seiner Nase, er erstarrte und blieb wie aus Stein gemeißelt stehen. Samurai Dubix schaute sich um und sah, wie Hugi Hu, Meister des Drachenatems, Billy Bock und Mister Zylinder in Schach hielt. Samurai Dubix pfiff nach Libero Bimako. Der setzte zu einem Flugsprung an und landete auf dem Gesicht von Mister Zylinder, der vor Schreck das Schwert fallen ließ. Kaum lag es auf dem Boden, hauchte es Hugi Hu an, es flammte kurz heißlodernd auf und schmolz. Blong! Schon landete das Schwert von Samurai Dubix auf Mister Zylinders Nasenspitze und er erstarrte ebenfalls. Ungläubig blickte Billy Bock auf das Geschehen, schwang sich vor Angst schlotternd auf sein Motorrad und raste auf Nimmerwiedersehen davon. Zufrieden sahen sich die Kliminjas an. </p>
		  <p>Wo aber war Gigi Ninjiki und wo war Lord Knatterdon? Lord Knatterdon war im Haus zurückgeblieben und völlig überrascht, als Gigi Ninjiki plötzlich vor ihm stand. Es dauerte nicht lange, da hatte sie Lord Knatterdon mit ihrer Superkraft gefesselt. Gigi Ninjiki war nämlich die Meisterin des Vorlesens und niemandem ist es bis heute gelungen, dieser Superkraft etwas entgegenzusetzen. Wie verhext lauschten ihr also auch Lord Knatterdon und — nachdem sie wieder aufgewacht waren — Mister Zylinder und Sausepuff. Ein ganzes Buch las ihnen Gigi Ninjiki vor und am Ende des Tages hatten die drei zumindest so viel verstanden, dass sie den Giftmüll am nächsten Morgen beim Umweltamt meldeten. Gigi Ninjiki bannte die Gang noch oft mit ihrer Superkraft. So begannen die schweren Jungs über sich nachzudenken und hörten auf, die Nin Yorker zu terrorisieren. Ihrem alten Kumpel Billy Bock, der zu seiner Tante nach Tabuki geflohen war, schickten sie übrigens bald eine Postkarte. Auf ihr stand geschrieben: </p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'ninjageschichten',
  data () {
    return {
      who: 'ninjageschichten'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)  
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Gigi_Ninjiki_Titel.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Ninjiki_Atmo2.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false) 
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }  
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* ninjageschichten */
.ninjageschichten { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.ninjageschichten .himmel { display: block !important; }

.ninjageschichten .geschichte { position: absolute; top: 170px; left:51%;  }

.ninjageschichten .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.ninjageschichten .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

/* ninjageschichten .schwimmer {position: absolute; left: 28%; top: 39%; } */
.ninjageschichten .schwimmer {position: absolute; left: 25%; top: 12%; }
.ninjageschichten .schwimmer img{animation: schwimmer_erscheint 10s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; margin-left: -870px;}
@keyframes schwimmer_erscheint {
    0% {margin-left: -870px; opacity:0;}
    25% { opacity:1;}
    100% {margin-left: 0px; opacity:1;}
}
.ninjageschichten .fuchs_animation {
  width: 122px !important;
  height: 204px !important;
  background: url('/static/assets/ninjageschichten/Wassergeist_Animation.png') top center;
  animation: fuchs_animation 3s steps(15) infinite;
  animation-delay: 0.4s;
  transform: scale(1);
}


.ninjageschichten .lord_knatterdorn {position: absolute; left: 690PX; bottom: 40PX;}
.ninjageschichten .lord_knatterdorn {animation: lord_knatterdorn_erscheint 0.5s ease-out; animation-delay: 1.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-left: -270px; */}
@keyframes lord_knatterdorn_erscheint {
    /* 50% {margin-left: -270px;opacity:0;}
    100% {margin-left: 0px; opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.ninjageschichten .hugi {position: absolute; right: 1298px;
    bottom: 692px;}
.ninjageschichten .hugi {animation: hugi_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .ninjageschichten .dubix {position: absolute; left: 660px;
    bottom: 390px;}
.ninjageschichten .dubix {animation: hugi_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.libero {
    position: absolute;
    top: 44px;
    left: 1030px;
}
  .ninjageschichten .gigi {position: absolute;     left: 340px;
    bottom: 240px;}
.ninjageschichten .gigi {animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}

.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.ninjageschichten .hovering1 {
  -webkit-animation: hovering 18s linear infinite;
  -moz-animation: hovering 18s linear infinite;
  -ms-animation: hovering 18s linear infinite;
  -o-animation: hovering 18s linear infinite;
  animation: hovering 18s linear infinite;
}
.ninjageschichten .hovering2 {
  -webkit-animation: hovering 22s linear infinite;
  -moz-animation: hovering 22s linear infinite;
  -ms-animation: hovering 22s linear infinite;
  -o-animation: hovering 22s linear infinite;
  animation: hovering 22s linear infinite;
}
.ninjageschichten .hovering3 {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}
.ninjageschichten .hovering4 {
  -webkit-animation: hovering 24s linear infinite;
  -moz-animation: hovering 24s linear infinite;
  -ms-animation: hovering 24s linear infinite;
  -o-animation: hovering 24s linear infinite;
  animation: hovering 24s linear infinite;
}
/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,0px);
    -moz-transform: translate(20px,0px);
    -webkit-transform: translate(20px,0px);
    -o-transform: translate(20px,0px);
    transform: translate(20px,0px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.ninjageschichten .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/
 
.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}
 
.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}
 
.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}
 
.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}
 
.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}
 
.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
/*************** SIMPLE INNER SCROLLBAR ***************/
 
.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}
 
.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */
 
.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69; 
    box-shadow: inset 0 0 0px #ac8a69; 
    -webkit-border-radius: 0;
    border-radius: 0;
}
 
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69; 
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69; 
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat; 
}
	.ninjageschichten .lampe {position: relative;
    left: -470px;
   bottom: 265px;}
	
.lampe_animation {
  width: 2880px;
  height: 1620px;
  background: url('/static/assets/ninjageschichten/lampe_animation.png') top center;
  animation-delay: 1s;
  animation: lampe_animation 4s steps(12) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes lampe_animation {
    100% { background-position: 0 -19440px; }
}
.ratte {
    position: absolute;
    bottom: 0;
    left: 390px;
}
.ratte_animation {
  width: 320px;
  height: 82px;
  background: url('/static/assets/ninjageschichten/ratte_animation.png') top center;
  animation-delay: 1s;
  animation: ratte_animation 5s steps(20) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes ratte_animation {
	100% { background-position: 0 -1640px; }
}
.sterne {
    position: absolute;
    left: -486px;
    top: -270px;
}
.sterne_animation {
  width: 2881px;
  height: 1140px;
  background: url('/static/assets/ninjageschichten/sterne_animation.png') top center;
  animation-delay: 1s;
  animation: sterne_animation 3s steps(7) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes sterne_animation {
	100% { background-position: 0 -7980px; }
}	

span { font-family: FrozenMemory; }
.geschichte .player { top: 670px !important;     left: 100px; }
.spacegeschichten .player {position: absolute !important;left: 95px !important;}

.ninjageschichten #ninjageschichten_target .current-word {
    color: #e8f5fd !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Ninjageschichten.vue